module.exports = __webpack_public_path__ + "update-membership-details-white.svg?521bbec818b5d91643534dde2270251a";